export default function EditIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00007 13.3333H14.0001M10.0001 3.33334L12.0001 5.33334M10.9174 2.41467C11.1828 2.14928 11.5427 2.00018 11.9181 2.00018C12.2934 2.00018 12.6533 2.14928 12.9187 2.41467C13.1841 2.68007 13.3332 3.04002 13.3332 3.41534C13.3332 3.79066 13.1841 4.15061 12.9187 4.41601L4.91207 12.4233C4.75346 12.5819 4.55741 12.698 4.34207 12.7607L2.4274 13.3193C2.37003 13.3361 2.30923 13.3371 2.25134 13.3222C2.19345 13.3074 2.14062 13.2773 2.09836 13.235C2.05611 13.1928 2.02599 13.14 2.01116 13.0821C1.99633 13.0242 1.99733 12.9634 2.01407 12.906L2.57273 10.9913C2.63555 10.7762 2.75156 10.5804 2.91007 10.422L10.9174 2.41467Z"
        stroke="#71717A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
